import TopicOne from "../meta-trader-4-mobile-contents/TopicOne";

const MetaTrader4MobileContentOne = () => {
  return (
    <>
      <TopicOne />

      <div className="how__work__platform">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="thumb-left">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/platforms/meta_trader_4_mobile/meta_trader_4_mobile_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="content-right">
                <h2>The Power of MT4 in Your Pocket</h2>
                <p>
                  MetaTrader 4 Mobile brings the familiarity and functionality
                  of the desktop version straight to your iOS and Android
                  devices. Designed for traders who demand speed and simplicity,
                  it offers one-tap order execution, live market monitoring, and
                  technical charting tools, all optimized for mobile
                  performance. Stay informed, react quickly, and manage your
                  trades with confidence wherever you go. The clean, intuitive
                  interface ensures a smooth trading experience even during fast
                  market movements. Push notifications keep you updated on price
                  changes and key market events in real time. With full account
                  management at your fingertips, you’re always in control, no
                  matter where the markets take you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MetaTrader4MobileContentOne;
